import { useCallback, useEffect, useState } from "react";
import api from "../../axios/axiosInstance";

const useBatchAssessmentData = ({
    subjectId,
    unitId,
    termNumber,
    studentIds = [],
}) => {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const baseUrl = process.env.REACT_APP_BACKEND_URL;

    const fetchBatchAssessment = useCallback(async () => {
        if (
            !subjectId ||
            !unitId ||
            !termNumber ||
            studentIds.length === 0
        ) {
            setData(null);
            setError(null);
            return;
        }

        setIsLoading(true);
        setError(null);

        try {
            const response = await api.get(
                `${baseUrl}/grades/progress-card/batch/retrieve/`,
                {
                    params: {
                        subject: subjectId,
                        unit: unitId,
                        term_number: Number(termNumber),
                        students: studentIds.join(","),
                    },
                    withCredentials: true,
                }
            );

            setData(response.data);
        } catch (err) {
            console.error(
                "Failed to retrieve batch assessment:",
                err
            );

            setError(
                err.response?.data?.error ||
                    "Unable to load batch assessment."
            );

            setData(null);
        } finally {
            setIsLoading(false);
        }
    }, [
        baseUrl,
        subjectId,
        unitId,
        termNumber,
        studentIds,
    ]);

    useEffect(() => {
        fetchBatchAssessment();
    }, [fetchBatchAssessment]);

    return {
        data,

        // Convenient pieces of the response
        skills: data?.skills || [],
        dokLevels: data?.dok_levels || [],
        students: data?.students || [],

        totalStudents: data?.total_students || 0,
        totalSkills: data?.total_skills || 0,

        isLoading,
        error,

        refetch: fetchBatchAssessment,
    };
};

export default useBatchAssessmentData;